module.exports = __webpack_public_path__ + "static/media/arrow-left.eff10dd1.svg";